import React from "react"
import { Box, Container, useTheme } from "@mui/material"
import { Outlet } from "react-router-dom"
import { IPageLayoutProps } from "layouts/interface"

export const PageLayout: React.FC<IPageLayoutProps> = ({
  children,
  header = null,
  footer = null,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, navBuffer, contentWrapper } = styleOverrides

  return (
    <Box sx={root} {...props} data-name="PageLayout">
      <Container maxWidth="md" sx={contentWrapper} className="content">
        <Outlet />
      </Container>
      <Box sx={navBuffer}></Box>
    </Box>
  )
}
